import { DATE_FORMAT } from "helpers/common";
import React from "react";
const Columns = ({
  onCliclNavigate,
  currentPage,
  pageSize,
  handleEdithandler,
  handleUserStatus,
}) => [
  {
    dataField: "",
    text: "SrNo",
    formatter: (cell, row, rowIndex) => (
      <span className="text-capitalize cursor-pointer">
        {(currentPage - 1) * pageSize + (rowIndex + 1)}
      </span>
    ),
  },
  {
    dataField: "image",
    text: "Image",
    formatter: (cell, row) => (
      <img
        src={row.image || "https://via.placeholder.com/50"} // Fallback image
        alt="thumbnail"
        style={{
          width: "50px",
          height: "50px",
          objectFit: "cover",
          borderRadius: "4px",
        }}
      />
    ),
  },
  {
    dataField: "room_name",
    text: "Room Name",
    formatter: (_, row) => <span className="text">{row.name}</span>,
  },
  {
    dataField: "description",
    text: "Description",
    formatter: (_, row) => (
      <span className="text">{row?.description || "--"}</span>
    ),
  },

  {
    dataField: "category",
    text: "Category",
    formatter: (_, row) => <span className="text">{row.category_name}</span>,
  },
  //  {
  //     dataField: "total_members",
  //     text: "Total Members",
  //     formatter: (_, row) => <span className="text">{row.total_members}</span>,
  //   },
  {
    text: "Status",
    dataField: "status",
    formatter: (_, row) => (
      <span>
        {row?.status && row.status == "1" ? (
          <button
            className="fas fa-toggle-on"
            style={{
              fontSize: "20px",
              color: "green",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Active"
            onClick={() => handleUserStatus(row, "0")}
          ></button>
        ) : (
          <button
            className="fas fa-toggle-off"
            style={{
              fontSize: "20px",
              color: "red",
              backgroundColor: "#fff",
              border: "none",
            }}
            title="Inactive"
            onClick={() => handleUserStatus(row, "1")}
          ></button>
        )}
      </span>
    ),
  },
  {
    text: "Created At",
    dataField: "createdAt",
    formatter: (_, row) => DATE_FORMAT(row.createdAt),
  },
  {
    text: "Action",
    dataField: "",
    formatter: (_, row) => (
      <>
        <button
          className="fas fa-pen"
          style={{
            fontSize: "16px",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="Edit"
          onClick={() => handleEdithandler(row)}
        ></button>
        <button
          className="fa fa-eye"
          style={{
            fontSize: "20px",
            color: "green",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="View"
          onClick={() => onCliclNavigate(row)}
        ></button>
        {/* <button
          className="fa fa-trash-alt"
          style={{
            fontSize: "20px",
            color: "red",
            backgroundColor: "#fff",
            border: "none",
          }}
          title="delete"
          onClick={() => deleteHandler(row?.id)}
        ></button> */}
      </>
    ),
  },
];
export default Columns;
